// extracted by mini-css-extract-plugin
export default {"layout-root":"vkBH8NWy0g9k9ZonAZkX","main-content":"LTJdZRuyzAsEJh31DLpM"};